import React from 'react'

const PricingCard = props => {
  return (
    <ul className="theplan">
      <li className="title">
        <b>{props.title}</b>
        <br />
      </li>
      <li>
        <b>Digital File: </b>
        ${props.digital}
        <br />High quality, non watermarked digital file emailed you to be
        shared on facebook or anywhere else online
      </li>
      <li>
        <b>Printed 8X10 + Digital File: </b>
        ${props.printed}
        <br />High quality, non watermarked printed 8X10 plus a free copy of the
        digital file
      </li>
      <li>
        <b>Full Ride: </b> ${props.full}
        <br /> High quality, non watermarked digital files of entire ride.
        (Minimum 5 pictures)
      </li>
    </ul>
  )
}

export default PricingCard



// WEBPACK FOOTER //
// ./src/components/PricingCards/PricingCard.js